/** OPTION B — Corporate Split. 60/40 warm-white/deep-navy. */
import { ArrowRight, Loader2, ChevronLeft } from "lucide-react";
import { useLoginAuth } from "./useLoginAuth";

export default function OptionB() {
  const a = useLoginAuth();
  return (
    <div className="min-h-screen grid lg:grid-cols-[60fr_40fr]" data-testid="login-option-b">
      {/* LEFT — warm white */}
      <section className="bg-[color:var(--st-bg)] px-10 pt-14 pb-10 flex flex-col justify-between">
        <div>
          <div className="text-[13px] font-semibold tracking-[0.14em] text-[color:var(--st-text)]">SUNTRONIX ONE</div>
          <div className="text-[11px] uppercase tracking-[0.18em] text-[color:var(--st-text-muted)] mt-1">Enterprise Portal</div>
        </div>
        <div className="max-w-lg">
          <h1 className="font-heading text-[44px] leading-[1.05] tracking-[-0.02em] text-[color:var(--st-text)] font-medium">
            Technology operations.<br /><span className="text-[color:var(--st-text-muted)] font-normal">One intelligent platform.</span>
          </h1>
          <p className="mt-5 text-[14px] leading-[1.7] text-[color:var(--st-text-muted)]">
            Manage every technology asset, employee and lifecycle through one trusted workspace.
          </p>
        </div>
        <div className="text-[11px] uppercase tracking-[0.18em] text-[color:var(--st-text-subtle)] flex flex-wrap gap-x-6 gap-y-2">
          {["Procure","Deploy","Manage","Support","Recover","Reuse","Recycle"].map(s => (
            <span key={s}>· {s}</span>
          ))}
        </div>
      </section>

      {/* RIGHT — deep navy */}
      <section className="bg-[color:var(--st-text)] text-white px-10 py-14 flex items-center">
        <div className="w-full max-w-[340px] mx-auto">
          <div className="text-[10px] uppercase tracking-[0.18em] text-white/50">Welcome back</div>
          <h2 className="font-heading text-[26px] font-medium mt-1">Sign in to your workspace</h2>
          {a.step === "email" ? (
            <form onSubmit={a.continueEmail} className="mt-8 space-y-4">
              <DarkField label="Work email" value={a.email} onChange={a.setEmail} type="email" required autoFocus />
              {a.error && <ErrorMsg msg={a.error} />}
              <button type="submit" disabled={a.loading || !a.email} className="w-full h-11 rounded-md bg-[#B7803F] text-white font-medium inline-flex items-center justify-center gap-2 disabled:opacity-50 hover:bg-[#A2712F]" data-testid="b-continue">
                {a.loading ? <Loader2 className="h-4 w-4 animate-spin" /> : (<>Continue <ArrowRight className="h-4 w-4" strokeWidth={1.6}/></>)}
              </button>
            </form>
          ) : (
            <form onSubmit={a.submitPassword} className="mt-8 space-y-4">
              <button type="button" onClick={a.backToEmail} className="text-[12px] text-white/60 hover:text-white inline-flex items-center gap-1">
                <ChevronLeft className="h-3.5 w-3.5"/> {a.email}
              </button>
              {a.tenantHint?.sso_enabled && a.tenantHint?.sso_url && (
                <a href={a.tenantHint.sso_url} className="w-full h-11 rounded-md border border-white/20 text-white text-[13px] font-medium inline-flex items-center justify-center hover:bg-white/5">
                  Continue with Enterprise SSO
                </a>
              )}
              <DarkField label="Password" value={a.password} onChange={a.setPassword} type="password" required autoFocus />
              {a.error && <ErrorMsg msg={a.error} />}
              <button type="submit" disabled={a.loading} className="w-full h-11 rounded-md bg-[#B7803F] text-white font-medium disabled:opacity-50 inline-flex items-center justify-center">
                {a.loading ? <Loader2 className="h-4 w-4 animate-spin"/> : "Sign in"}
              </button>
            </form>
          )}
          <div className="mt-10 text-[10px] uppercase tracking-[0.18em] text-white/40">Powered by SUNTRONIX ONE</div>
        </div>
      </section>
    </div>
  );
}

function DarkField({ label, value, onChange, ...p }) {
  return (
    <label className="block">
      <span className="text-[10px] uppercase tracking-[0.14em] text-white/60">{label}</span>
      <input {...p} value={value} onChange={(e) => onChange(e.target.value)}
        className="mt-2 w-full h-11 px-3 rounded-md bg-white/5 border border-white/15 text-white text-[15px] placeholder:text-white/30 focus:outline-none focus:border-white/40 focus:ring-2 focus:ring-white/10" />
    </label>
  );
}
function ErrorMsg({ msg }) { return <div role="alert" className="text-[12px] text-rose-200 bg-rose-500/15 border border-rose-500/30 rounded-md px-3 py-2">{msg}</div>; }
